<div class="container-fluid my-3">
    <!-- Header -->
    <div class="mb-4">
        <h3 class="mb-0">{{ 'titles_createUser' | translate: 'online' : 'userAdministration' }}</h3>
    </div>

    <!-- Form -->
    <form
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()"
        class="mt-3 mb-3 mx-auto slim-card-container">
        <div>
            <div class="card mb-3">
                <div class="card-body">
                    <div class="mb-3">
                        <h5 class="mb-0">
                            {{ 'titles_userInfo' | translate: 'online' : 'userAdministration' }}
                        </h5>
                    </div>
                    <app-input-text-group
                        formControlName="personName"
                        [label]="'properties_name' | translate: 'online' : 'userAdministration'" />
                    <app-input-text-group
                        formControlName="userName"
                        [label]="'properties_username' | translate: 'online' : 'userAdministration'"
                        [maxLength]="50" />
                    <app-input-text-group
                        formControlName="email"
                        [label]="'properties_email' | translate: 'online' : 'userAdministration'" />
                    <app-input-select-option-group
                        formControlName="role"
                        [label]="'properties_role' | translate: 'online' : 'userAdministration'"
                        [data]="roleOptions" />
                    <app-input-text-area-group
                        formControlName="note"
                        [label]="'properties_note' | translate: 'online' : 'userAdministration'"
                        [maxLength]="100" />
                </div>
            </div>
        </div>

        <!-- System access (User role only) -->
        @if (showSystemAccess()) {
            <app-system-access-picker
                [assignedBuildingNos]="assignedBuildingNos()"
                (assignedBuildingNosChange)="assignedBuildingNos.set($event)" />
        }

        <!-- Actions -->
        <div class="text-end mt-3">
            <button
                class="btn btn-primary"
                type="submit"
                [disabled]="formGroup.pending || isSaving()">
                {{ 'actions_createUser' | translate: 'online' : 'userAdministration' }}
            </button>
        </div>
    </form>
</div>
